import { render, staticRenderFns } from "./InfoTableBase.vue?vue&type=template&id=d65450fc&scoped=true&"
import script from "./InfoTableBase.vue?vue&type=script&lang=js&"
export * from "./InfoTableBase.vue?vue&type=script&lang=js&"
import style0 from "./InfoTableBase.vue?vue&type=style&index=0&id=d65450fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d65450fc",
  null
  
)

/* custom blocks */
import block0 from "@/locales/common.locale?vue&type=custom&index=0&blockType=i18n&issuerPath=E%3A%5Capp%5CJenkins%5Cworkspace%5CAll_IaaS_Farm%5C0%20nextoreV3bdclient_build%5Csrc%5Csrc%5Ccomponents%5Cinfo%5Ccomponents%5CInfoTableBase.vue"
if (typeof block0 === 'function') block0(component)
import block1 from "@/locales/components/info/InfoNewsTable.json?vue&type=custom&index=1&blockType=i18n&issuerPath=E%3A%5Capp%5CJenkins%5Cworkspace%5CAll_IaaS_Farm%5C0%20nextoreV3bdclient_build%5Csrc%5Csrc%5Ccomponents%5Cinfo%5Ccomponents%5CInfoTableBase.vue"
if (typeof block1 === 'function') block1(component)

export default component.exports